// extracted by mini-css-extract-plugin
export default {"legalTextBanner":"legaltext-banner_legalTextBanner__wP4lw","legalTextContent":"legaltext-banner_legalTextContent__I5emq"};